<template>
  <SettingsPageLayout>
    <div class="max-w-3xl m-auto flex flex-col">
      <div class="flex items-center justify-between mb-8">
        <h1 class="block text-2xl font-bold leading-6 text-gray-900">Workflows</h1>
        <Button size="sm" @click="showNewWorkflow = true">New Workflow</Button>
      </div>

      <HFetchQuery :query="workflowsQuery">
        <template #default="{ data: workflows }">
          <template v-if="workflowDefinitionStore.isLoaded">
            <WorkflowListItem
              v-for="workflow in workflows"
              :key="workflow.id"
              class="mb-3"
              :workflow="workflow"
              @status-changed="handleStatusChanged"
            />
            <ZeroState v-if="workflows.length === 0">There are currently no workflows for your team.</ZeroState>
          </template>
        </template>
      </HFetchQuery>
    </div>
  </SettingsPageLayout>

  <NewWorkflowDialog
    v-if="showNewWorkflow"
    v-model:open="showNewWorkflow"
    :existing-workflow-names="existingWorkflowNames"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { WorkflowStatus } from '@/api/entity_types/workflow/Workflow';
import { Api } from '@/api';
import NewWorkflowDialog from './NewWorkflowDialog.vue';
import { Button } from '@/components/ui/button';
import { useWorkflowDefinitionsStore } from '@/stores/workflow/workflowDefinitions';
import ZeroState from '@/components/ZeroState.vue';
import WorkflowListItem from './WorkflowListItem.vue';
import SettingsPageLayout from '@/components/layouts/SettingsPageLayout/index.vue';
import { useHFetchQuery } from '@/lib/hfetch/useHFetchQuery';
import HFetchQuery from '@/lib/hfetch/HFetchQuery.vue';

const showNewWorkflow = ref<boolean>(false);
const workflowDefinitionStore = useWorkflowDefinitionsStore();

const workflowsQuery = useHFetchQuery(() => Api.Workflows.listWorkflows());

const existingWorkflowNames = computed(() => (workflowsQuery.data.value ?? []).map(workflow => workflow.name));

const handleStatusChanged = (workflowId: number, newStatus: WorkflowStatus) => {
  const workflow = workflowsQuery.data.value?.find(w => w.id === workflowId);
  if (workflow) workflow.status = newStatus;
};
</script>
